export const IntervalToPollForMachineUpdatesInMilliSeconds = 7500;

export const AdyenPaymentCountryCode = "US";
